import React from 'react';
import { Navbar, Nav } from "react-bootstrap";
import SiteImage1 from '../images/web sites/startup.png';
import siteImage2 from '../images/web sites/nevprovidence.png';
import siteImage3 from '../images/web sites/hijab-2021.png';
import siteImage4 from '../images/web sites/one position.png';

import generateImage1 from '../images/General Pages/circuler-progre.png';
import generateImage2 from '../images/General Pages/Dom-Dom-game.png';
import generateImage3 from '../images/General Pages/email-validation.png';
import generateImage4 from '../images/General Pages/image-change-effect.png';
import generateImage5 from '../images/General Pages/image-comparision-slider.png';
import generateImage6 from '../images/General Pages/LightBox Image Gallary.png';
import generateImage7 from '../images/General Pages/Login-Web-Page.png';
import generateImage8 from '../images/General Pages/make-image-gallary.png';
import generateImage9 from '../images/General Pages/make-login.png';
import generateImage10 from '../images/General Pages/slider-button-frist.png';
import generateImage11 from '../images/General Pages/To-Do-List-BookList.png';
import generateImage12 from '../images/General Pages/video-slider.png';
import generateImage13 from '../images/General Pages/weather-page.png';
import generateImage14 from '../images/General Pages/website-dark-mode.png';
import generateImage15 from '../images/General Pages/pokemon-api.png';
import generateImage16 from '../images/General Pages/css-responsive-prodact.png';
import generateImage17 from '../images/General Pages/animated-profile.png';
import generateImage18 from '../images/General Pages/country-guide-app.png'

import animeJsImage1 from '../images/Anime Js  Pages/animation-effects.png';
import animeJsImage2 from '../images/Anime Js  Pages/flaying-text-animation.png';
import animeJsImage3 from '../images/Anime Js  Pages/pure-text-typing.png';
import animeJsImage4 from '../images/Anime Js  Pages/shining-text-animation.png';
import animeJsImage5 from '../images/Anime Js  Pages/text-animation-effects.png';
import animeJsImage6 from '../images/Anime Js  Pages/Text-Animation-Js.png'

import animationImage1 from '../images/Animation Pages/3D-image-SlideShow.png';
import animationImage2 from '../images/Animation Pages/buttons-effects.png';
import animationImage3 from '../images/Animation Pages/shoes-page.png';
import animationImage4 from '../images/General Pages/bootstrap-shablon-page.png';
import animationImage5 from '../images/General Pages/page-title.png';
import animationImage6 from '../images/General Pages/smoki-animation-effects.png';
import animationImage7 from '../images/General Pages/animated-video.png';

const Portfolio = () => {
  return (
    <div className='portfolia' id='portfolio'>
      <h1>Portfolio</h1>
      <div className="my-portfolio-header row">
        <h2 className="siteTitle">Web Sites</h2>
        <div className="web-sites row">
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://web-site-startup.netlify.app" alt="Start Up" target="_blank" rel="noreferrer" title='Start Up'>
              <img src={SiteImage1} id="image1" alt="Start Up" />
            </a>
            
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://nev-providence.netlify.app" alt="New Providence" target="_blank" rel="noopener noreferrer" title="Nev Provider">
              <img src={siteImage2} id="image2" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://hijab-2021.netlify.app" alt="Hijab" target="_blank" rel="noreferrer" title='Hijab 2021'>
              <img src={siteImage3} id="image3" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://one-position.netlify.app" alt="One-Position" target="_blank" rel="noreferrer" title='One Position'>
              <img src={siteImage4} id="image4" alt="error" />
            </a>
          </div>
        </div>
      </div>
      <div className="my-portfolio-header row">
        <h2 className="siteTitle">General Pages</h2>
        <div className="web-sites row">
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://circular-progres.netlify.app" alt="Circular Progres" title="Circular Progres" target="_blank" rel="noreferrer">
              <img src={generateImage1} id="image1" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://dom-dom-ziki.netlify.app" alt="dom dom ziki" target="_blank" rel="noopener norefer noreferrer" title="dom-dom-ziki">
              <img src={generateImage2} id="image2" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://emai-validation.netlify.app" alt="Emai Validation" title="Emai Validation" target="_blank" rel="noopener noreferrer">
              <img src={generateImage3} id="image3" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://backgroud-image-change-effect.netlify.app" alt="Backgroud Image Change Effect" title="Backgroud Image Change Effect" target="_blank" rel="noopener noreferrer">
              <img src={generateImage4} id="image4" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://image-comparition-slider.netlify.app" alt="Image Comparition Slider" title="Image Comparition Slider" target="_blank" rel="noopener noreferrer">
              <img src={generateImage5} id="image5" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://lightbox-image-gallary.netlify.app" alt="Lightbox Image Gallary" title="Lightbox Image Gallary" target="_blank" rel="noopener noreferrer">
              <img src={generateImage6} id="image6" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://login-effect-web-page.netlify.app" alt="Login Effect Web Page" title="Login Effect Web Page" target="_blank" rel="noopener noreferrer">
              <img src={generateImage7} id="image7" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://make-image-gallary.netlify.app" alt="Make Image Gallary" title="Make Image Gallary" target="_blank" rel="noopener noreferrer">
              <img src={generateImage8} id="image8" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://make-login.netlify.app" alt="Make Login" title="Make Login" target="_blank" rel="noopener noreferrer">
              <img src={generateImage9} id="image9" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://slider-button-frist.netlify.app" alt="Slider Button Frist" title="Slider Button Frist" target="_blank" rel="noopener noreferrer">
              <img src={generateImage10} id="image10" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://to-do-list-boklist.netlify.app" alt="To Do List Boklist" title="To Do List Boklist" target="_blank" rel="noopener noreferrer">
              <img src={generateImage11} id="image11" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://video-slider-effect.netlify.app" alt="Video Slider Effect" title="Video Slider Effect" target="_blank" rel="noopener noreferrer">
              <img src={generateImage12} id="image12" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://weather-api-page.netlify.app" alt="Weather Api Page" title="Weather Api Page" target="_blank" rel="noopener noreferrer">
              <img src={generateImage13} id="image13" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://website-dark-mode.netlify.app" alt="Web Site Dark Mode" title="Web Site Dark Mode" target="_blank" rel="noopener noreferrer">
              <img src={generateImage14} id="image14" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://pokeman-card-api-generation.netlify.app" alt="Pokeman Card Api Generation" title="Pokeman Card Api Generation" target="_blank" rel="noopener noreferrer">
              <img src={generateImage15} id="image15" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://css-responsive-prodact.netlify.app" alt="Css Responsive Prodact" title="Css Responsive Prodact" target="_blank" rel="noopener noreferrer">
              <img src={generateImage16} id="image16" alt="error" />
            </a>
          </div>      
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://https://animated-profile.netlify.app" alt="Animated Profile" title="Animated Profile" target="_blank" rel="noopener noreferrer">
              <img src={generateImage17} id="image17" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://country-guide-app.netlify.app/" alt="Country Guide App" title="Country Guide App" target="_blank" rel="noopener noreferrer">
              <img src={generateImage18} id="image18" alt="error" />
            </a>
          </div>
        </div>
      </div>
      <div className="my-portfolio-header row">
        <h2 className="siteTitle">Anime Js Pages</h2>
        <div className="web-sites row">
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://animation-effects.netlify.app" alt="Animation Effects" target="_blank" title="Animation Effects" rel="noopener noreferrer">
              <img src={animeJsImage1} id="image1" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://flaying-text-animation.netlify.app" alt="Flaying Text Animation" target="_blank" title="Flaying Text Animation" rel="noopener noreferrer">
              <img src={animeJsImage2} id="image2" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://pure-text-typing.netlify.app" alt="Pure Text Typing" target="_blank" title="Pure Text Typing" rel="noopener noreferrer">
              <img src={animeJsImage3} id="image3" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://shining-text-animation.netlify.app" alt="Shining Text Animation" target="_blank" title="Shining Text Animation" rel="noopener noreferrer">
              <img src={animeJsImage4} id="image4" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://text-animation-effects.netlify.app" alt="Text Animation Effects" target="_blank" title="Text Animation Effects" rel="noopener noreferrer">
              <img src={animeJsImage5} id="image5" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://text-animation-vanilajs.netlify.app" alt="Text Animation Vanila Js" target="_blank" title="Text Animation Vanila Js" rel="noopener noreferrer">
              <img src={animeJsImage6} id="image6" alt="error" />
            </a>
          </div>
        </div>
      </div>
      <div className="my-portfolio-header row">
        <h2 className="siteTitle">Animation Pages</h2>
        <div className="web-sites row">
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://3d-images-animation.netlify.app" alt="3D Images Animation" target="_blank" title="3D Images Animation" rel="noopener noreferrer">
              <img src={animationImage1} id="image1" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://color-buttons-effects.netlify.app" alt="Color Buttons Effects" target="_blank" title="Color Buttons Effects" rel="noopener noreferrer">
              <img src={animationImage2} id="image2" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://shoes-pages.netlify.app" alt="Shoes Pages" target="_blank" title="Shoes Pages" rel="noopener noreferrer">
              <img src={animationImage3} id="image3" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://bootstrap-shablon.netlify.app" alt="Bootstrap Shablon" target="_blank" title="Bootstrap Shablon" rel="noopener noreferrer">
              <img src={animationImage4} id="image4" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://awesome-css-border-animation.netlify.app" alt="Awesome Css Border Animation" target="_blank" title="Awesome Css Border Animation" rel="noopener noreferrer">
              <img src={animationImage5} id="image5" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">     
            <a href="https://smoke-animation-effect.netlify.app" alt="Smoke Animation Effect" target="_blank" title="Smoke Animation Effect" rel="noopener noreferrer">
              <img src={animationImage6} id="image6" alt="error" />
            </a>
          </div>
          <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 images">
            <a href="https://animated-video.netlify.app" alt="Animated Video" target="_blank" title="Animated Video" rel="noopener noreferrer">
              <img src={animationImage7} id="image7" alt="error" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Portfolio